import { GlobalAxios } from "../axios/axios-config";
import {
  INewTicketAutomationMsgTicketAutTemplate,
  ITicketAutomationMsgTicketAutTemplate,
} from "../models/automation-message-ticket-automation-template";

const AUTOMATION_RULE_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationMsgTicketAutTemplate/";

export const createTicketAutomationMsgTicketAutTemplate = (
  item: INewTicketAutomationMsgTicketAutTemplate
) => {
  return GlobalAxios.post(AUTOMATION_RULE_ROUTE, item);
};

export const getTicketAutomationMsgTicketAutTemplateById = (id: string) => {
  return GlobalAxios.get<ITicketAutomationMsgTicketAutTemplate>(
    AUTOMATION_RULE_ROUTE + id
  );
};

export const updateTicketAutomationMsgTicketAutTemplateById = ({
  item,
  id,
}: {
  item: INewTicketAutomationMsgTicketAutTemplate;
  id: string;
}) => {
  return GlobalAxios.put(AUTOMATION_RULE_ROUTE + id, item);
};
